<template>
    <div class="error-page">
        <div class="ff-text text-center"> 
            <img class="error_icon" src="../assets/no_access.svg" /> 

            <div class="error_message">{{errorMessage}}
                <br/>
                {{lbl.error.return_main_page}}
            </div>   
            
            <div class="btn_return">{{lbl.error.back_to_main_page}}</div>   

            <img class="bzb_icon" src="../assets/logo_bzb_gray1.svg" /> 
        </div>
    </div>
</template>

<script>
import { useRoute } from "vue-router";   
import { ErrorType } from "@/helper/ErrorType.js";
import useLocaleStore from "../store/LocaleStore";

export default {
    name: 'Error',
    created: function() {
        document.title = "Error";
    },
    mounted: function () {
        this.init()
    },
    setup: function () { 
        const route = useRoute()
        const LocaleStore = useLocaleStore()

        return {  
            lbl: LocaleStore.lbl,
            route: route,
        }
    },
    data: function () {
        return {
            errorMessage: "",   
        }
    },
    methods: {  
        init: async function () { 
            var error_code = parseInt(this.route.params.error_code);
            console.log("error_code", error_code);  
            switch (error_code) {
                case ErrorType.AppMapping: // ไม่มี theme ที่ตรงในไฟล์ app_mapping.json
                    this.errorMessage = "Error ไม่มี theme ที่ตรงในไฟล์ app_mapping.json"; 
                    break;
                // case ErrorType.Theme: // ไม่มี Theme
                //     this.errorMessage = "Error ไม่มี theme "; 
                //     break;
                // case ErrorType.CampaignId: // CampaignId
                //     this.errorMessage = "Error ไม่มี campaign_id"; 
                //     break;
                // case ErrorType.Locale: // ไม่มี Locale
                //     this.errorMessage = "Error ไม่มี locale"; 
                //     break;
                // case ErrorType.ReturnUrl: // ไม่มี ReturnUrl
                //     this.errorMessage = "Error ไม่มี return_url"; 
                //     break;
                // case ErrorType.Version: // ไม่มี Version
                //     this.errorMessage = "Error ไม่มี version"; 
                //     break;
                case ErrorType.AccessKeyExpire: 
                    this.errorMessage = "Error access key expire"; 
                    break;
                default: 
                    this.errorMessage = "Error ส่ง param มาไม่ครบ theme, campaign_id, locale, return_url "; 
                    break;
            } 
            console.log(this.errorMessage); 
        },   
        clickBack : function() {
            var returnUrl = this.route.query.return_url;
            window.location.replace(returnUrl);
        },
    }
}
</script>


<style lang="scss">
@import '../style/main.scss';
</style>
<style lang="scss" scoped> 
@import '../style/base.scss';
    .error-page {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;  
        background-color: #f4f4f4;
        font-family: 'IPM-Regular';

        .ff-text { 
            margin: 0 25px;
        }
        .error_icon {
            width: 150px;
            height: 150px;
            margin: 0 auto;
        }
        .error_message {
            text-align: center;
            color: #000;
            margin-top:30px;
        }
        .btn_return { 
            height: 65px;
            flex-grow: 0; 
            border-radius: 40px;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
            background-color: #333;
            margin: 0 0;
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-family: 'IPM-SemiBold';
        }
        .bzb_icon{
            width: 90px;
            height: 18px; 
            position: fixed;
            bottom: 20px;
            left: 0;
            right: 0; 
            margin: 0 auto;
        }
    }
</style>
